<div class="accordion">
  <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/accordion/components/squeezebox.html